import React from 'react';

import RufsError from '../../errors/rufsError.jsx';

const CreateAgreementError = () => (
    <RufsError>
        Vi får ikke til å sende avtalen akkurat nå. Prøv igjen om litt.
    </RufsError>
);

export default CreateAgreementError;



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/createAgreementError.jsx